module.exports = __webpack_public_path__ + "img/img14.d04c744c.svg";